import { Routes } from "@angular/router";
import { HomePageComponent } from "./home-page.component";
import { developmentPageRoutes } from "../development-page/development-page.routes";
import { dropdownSettingsPageRoutes } from "../dropdown-settings-page/dropdown-settings-page.routes";
import { telegramPageRoutes } from "../telegram-page/telegram-page.routes";
import { notFoundPageRoutes } from "../not-found-page/not-found-page.routes";
import { pulseReportChartPageRoutes } from "../pulse-report-pages/pulse-report-chart-page.routes";
import { planFactPageRoutes } from "../plan-fact-page/plan-fact-page.routes";
import { releaseCalendarPageRoutes } from "../release-calendar-page/release-calendar-page.routes";
import { dailyFeedbackReportsPageRoutes } from "../daily-feedback-reports-page/daily-feedback-reports-page.routes";
import { hypothesesPageRoutes } from "../hypotheses-page/hypotheses-page.routes";
import { notesPageRoutes } from "../notes-page/notes-page.routes";
import { productCardPageRoutes } from "../product-card-page/product-card-page.routes";
import {
  advertisementIntegrationsPageRoutes
} from "../advertisement-integrations-page/advertisement-integrations-page.routes";
import { tablePageRoutes } from "../table-page/table-page.routes";
import { roleRedirectGuard } from "../../../core/guards/role-redirect.guard";
import { authGuard } from "../../../core/guards/auth.guard";

export const homePageRoutes: Routes = [
  {
    path: '',
    component: HomePageComponent,
    children: [
      ...pulseReportChartPageRoutes,
      ...planFactPageRoutes,
      ...releaseCalendarPageRoutes,
      ...dailyFeedbackReportsPageRoutes,
      ...hypothesesPageRoutes,
      ...notesPageRoutes,
      ...productCardPageRoutes,
      ...advertisementIntegrationsPageRoutes,
      ...tablePageRoutes,
      {
        path: '',
        canActivate: [roleRedirectGuard, authGuard],
        children: [],
        pathMatch: 'full'
      },
      ...developmentPageRoutes,
      ...dropdownSettingsPageRoutes,
      ...telegramPageRoutes,
      ...notFoundPageRoutes,
      {
        path: '',
        redirectTo: 'records',
        pathMatch: 'full'
      },
      {
        path: '**',
        redirectTo: '404'
      }
    ]
  }
]
